"use client";

// import { DndProvider } from "react-dnd";
// import { HTML5Backend } from "react-dnd-html5-backend";

import { Provider as JotaiProvider } from "jotai";
import { ThemeProvider } from "./theme-provider";
import { useTheme } from "@bpipartners/webui";

export function Providers({ children }: { children: React.ReactNode }) {
  const theme = useTheme();
  return (
    <JotaiProvider>
      <ThemeProvider attribute="class" defaultTheme={theme.palette.mode} disableTransitionOnChange enableColorScheme>
        {/* <DndProvider context={window} backend={HTML5Backend}>{children}</DndProvider> */}
        {children}
      </ThemeProvider>
    </JotaiProvider>
  );
}
